import { Typography } from "@mui/material";

import {
  formatNumberToDecimal,
  formatQuotingUnitOfMeasure,
  getCurrencyName,
} from "../../utils";

import type { SxProps, Theme, TypographyProps } from "@mui/material";

interface Props {
  price: number | null;
  currency: number | string | null;
  quotingUnitOfMeasure?: UnitOfMeasureType;
  variant?: TypographyProps["variant"];
  sx?: SxProps<Theme>;
}

export function ShipmentPriceText(props: Props) {
  const { price, currency, quotingUnitOfMeasure, variant, sx = {} } = props;

  if (price == null) {
    return null;
  }

  const getCurrencyDisplayLabel = () => {
    if (!currency) {
      return "-";
    }
    return getCurrencyName(currency);
  };

  const getPriceDisplay = () => {
    const formattedPrice = formatNumberToDecimal(price);
    if (quotingUnitOfMeasure && quotingUnitOfMeasure !== "ALL_IN") {
      return `${formattedPrice} ${formatQuotingUnitOfMeasure(quotingUnitOfMeasure, false)}`;
    }
    return formattedPrice;
  };

  return (
    <Typography variant={variant} sx={sx}>
      {`$${getPriceDisplay()} ${getCurrencyDisplayLabel()}`}
    </Typography>
  );
}
